import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  BaseUrl,
  GetPhonePayPaymentLink,
  RazorPayKey,
  RazorPayName,
  RazorPaySecretKey,
} from "../../BaseUrl/BaseUrl";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import Mylogo from "../../assets/images/new/newLogo.jpg";
import Select from "react-select";
import { ERROR_MESSAGES } from "../GlobalErrorMessage";
import CODPaymentModal from "../Payment Gateway/CODPaymentModal";
import fav from "../../assets/images/new/fav-removebg-preview.png";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { GetDeliveryCharges } from "../../ApiServices/EStore/EStoreApi";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { Nav, Tab } from "react-bootstrap";
import {
  Prasad_Cart,
  Prasad_CartList,
  Prasad_Order,
} from "../../ApiServices/Prasad/PrasadApi";
import {
  AuthContextProvider,
  LoaderContext,
} from "../../AuthContext/AuthContext";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { customSelectStyles } from "../../middlewares/Utils";
import { handleProceedRemainingPayment } from "../RazorPay/RazorPayFunction";
import { FaqModuleID } from "../enum";
import { GetUserWalletAmount } from "../../ApiServices/UserWallet/UserWalletApi";
import CouponModal from "../CouponModal";

const ViewCart = () => {
  const [qty, setQty] = useState();
  const [product, setProduct] = useState([]);
  const [total, setTotal] = useState(0);
  const [showProductDetails, setShowProductDetails] = useState(true);
  const [showProductTabDetails, setShowProductTabDetails] = useState(true);
  const [discount, setDiscount] = useState(0);
  const location = useLocation();
  const [showCodModal, setShowCodModal] = useState(false);
  const [error, setError] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [qqty, setQqty] = useState(0);
  const [shipCharges, setShippingCharges] = useState(0);
  const [deliveryChargesAmt, setDeliveryChargesAmt] = useState(0);
  const [totalDiscountAmount, setTotalDiscountAmount] = useState(0);
  const [isBothVisible, setIsBothVisible] = useState(false);
  const [isProductCart, setIsProductCart] = useState(false);
  const [isPrasadCart, setIsPrasadCart] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showAddressDetails, setShowAddressDetails] = useState(false);
  const [productID, setProductID] = useState([]);

  const [activeTab, setActiveTab] = useState(
    showProductDetails === null
      ? "address"
      : showAddressDetails
        ? "products"
        : !showAddressDetails
          ? "prasad"
          : ""
  );
  const [shipAdd, setShipAdd] = useState({
    PinCode: "",
    Flat: "",
    Colony: "",
    Landmark: "",
    City: "",
    State: "",
    Payment: "",
    countryID: null,
    districtID: "",
    stateID: "",
  });
  const {
    setLoader,
    loader,
    isLocationUpdate,
    setIsLocationUpdate,
    setIsCartUpdate,
    isCartUpdate,
  } = useContext(LoaderContext);
  const ProductCount = localStorage.getItem("cartItemCount");
  const prasadCount = localStorage.getItem("PrasadcartCount");
  const [isTabChange, setIsTabChange] = useState(false);
  const { isAuthenticated } = useContext(AuthContextProvider);
  const [loginPopUp, setLoginPopUp] = useState(null);
  const [modelRequestData, setModelRequestData] = useState({
    Action: null,
    CodPayload: null,
    totalVal: null,
    productName: null,
    productPrice: null,
    productID: null,
    moduleName: null,
    couponCode: null
  });
  const [showModal, setShowModal] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState({
    CouponCode: null,
    isApplied: false,
    CoupenAmount: 0,
    walletAmount: 0,
    couponCodeID: null
  });
  const userID = localStorage.getItem("userID");
  const [couponAmount, setCouponAmount] = useState(0)
  const [walletAmount, setWalletAmount] = useState(9000)
  const [isWalletApplied, setIsWalletApplied] = useState(false);

  const ValidationToast = () =>
    toast.error("Please fill all fields before proceeding with the payment.");

  useEffect(() => {

    console.log("moduleName", location?.state?.moduleName);
    if (location?.state?.moduleName === "prasadBooking") {
      setIsPrasadCart(true);
      setIsProductCart(false);
      setIsBothVisible(false);
      setIsTabChange(true);
    } else if (location?.state?.moduleName === "productBooking") {
      setIsPrasadCart(false);
      setIsProductCart(true);
      setIsBothVisible(false);
      setIsTabChange(false);
    } else if (location?.state?.moduleName === "All") {
      setIsPrasadCart(false);
      setIsProductCart(false);
      setIsBothVisible(true);
      setIsTabChange(false);
    }
    GetUserWalletAmountData()
  }, []);

  useEffect(() => {

    if (isWalletApplied && appliedCoupon?.isApplied === false) {
      const minAmount = Math.min(total, walletAmount);
      const discountAmount = Math.round(minAmount * 0.5);
      setAppliedCoupon((prev) => ({ ...prev, walletAmount: discountAmount }))
      setCouponAmount(discountAmount);
      // setCouponAmount(walletAmount)
    } else if (isWalletApplied === false && appliedCoupon?.isApplied === true) {
      setCouponAmount(appliedCoupon?.CoupenAmount)
    } else {
      setCouponAmount(0)
    }
  }, [isWalletApplied, appliedCoupon])

  useEffect(() => {
    if (isProductCart) {
      getProducts();
    } else if (isPrasadCart) {
      GetPrasadCart();
    } else {
      getProducts();
    }
    fetchCountryList();
  }, []);

  useEffect(() => {
    if (isTabChange) {
      GetPrasadCart();
    } else if (!isTabChange) {
      getProducts();
    }
  }, [isTabChange]);

  useEffect(() => {
    if (isTabChange) {
      if (product?.length > 0) {
        const calculatedTotal = product?.reduce(
          (total, item) => total + item.PrasadPrice * item.QUANTITY,
          0
        );
        const calculatedTotalDiscount = product?.reduce(
          (total, item) =>
            total + Math.round((item.PrasadPrice * item.DISCOUNT) / 100),
          0
        );
        setTotal(calculatedTotal);

        setDiscount(calculatedTotalDiscount);
      }
    } else {
      if (product?.length > 0) {
        const calculatedTotal = product?.reduce(
          (total, item) => total + item.PRODUCT_PRICE * item.QUANTITY,
          0
        );
        const calculatedTotalDiscount = product?.reduce(
          (total, item) =>
            total + Math.round((item.PRODUCT_PRICE * item.DISCOUNT) / 100),
          0
        );
        setTotal(calculatedTotal);
        setDiscount(calculatedTotalDiscount);
      }
    }
  }, [product]);

  useEffect(() => {
    fetchStateList(selectedCountry);
  }, [selectedCountry]);
  useEffect(() => {
    fetchDistrictList(selectedState);
  }, [selectedState]);
  useEffect(() => {
    setModelRequestData((PREV) => ({
      ...PREV,
      totalVal: PREV.totalVal + deliveryChargesAmt,
    }));
  }, [shipCharges]);

  useEffect(() => {
    if (countryList.length > 0) {
      const firstCountry = countryList[0];
      setSelectedCountry(firstCountry.value);
      setShipAdd((prev) => ({
        ...prev,
        Country: firstCountry.label, // Store Country Name
        countryID: firstCountry.value, // Store Country ID
      }));
      fetchStateList(firstCountry.value); // Fetch states for the first country
    }
  }, [countryList]); // Runs when countryList is updated


  useEffect(() => {
    if (total !== null && total !== undefined && total !== 0 && totalDiscountAmount !== null && totalDiscountAmount !== undefined && totalDiscountAmount !== 0) {
      setCouponObj((prev) => ({ ...prev, orderAmount: total - totalDiscountAmount }));
    } else {
      setCouponObj((prev) => ({ ...prev, orderAmount: 0 }));
    }
  }, [total, totalDiscountAmount])
  const GetUserWalletAmountData = async () => {

    setLoader(true);
    try {
      let response = await GetUserWalletAmount(userID); // Replace with actual import/function call
      if (response?.ResponseCode == "0") {
        setLoader(false);

        const list = response?.DATA || [];
        setWalletAmount(Number(list[0]?.WalletAmount) <= 0 ? 0 : list[0]?.WalletAmount)

      } else {
        console.error("Bad request");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleOpenCoupenModal = () => {

    setModelRequestData((prev) => ({ ...prev, moduleName: 'e-store' }))
    setShowModal(true)
  }
  const GetPrasadCart = async () => {

    const data = localStorage.getItem("userID") || "";
    if ((data === null || data === undefined || data === "") || location?.state?.moduleName !== "prasadBooking") {
      return;
    }
    setLoader(true);
    try {
      const response = await Prasad_CartList(
        {
          START: 0,
          END: 100,
          WORD: "none",
        },
        data
      );

      if (response?.ResponseCode == "0") {
        const responseData = response?.DATA || [];
        setLoader(false);
        setProduct(responseData);
        // Calculate total, discount, and quantity
        let discount = 0;
        let totalQuantity = 0;
        let subtotal = 0;

        responseData.forEach((product) => {
          const quantity = parseInt(product.QUANTITY) || 0;
          const price =
            product.PRODUCT_PRICE * product.QUANTITY -
            Math.round(
              (product.PRODUCT_PRICE * (product.DISCOUNT * product.QUANTITY)) /
              100
            );

          // const price = parseFloat(product.PRODUCT_PRICE) || 0;
          const discountPercent = parseFloat(product.DISCOUNT) || 0;

          const productTotal = price * quantity;
          totalQuantity += quantity;
          subtotal += price;

          if (discountPercent > 0) {
            discount += discountPercent * quantity;
          }
        });

        const finalDiscountPercentage =
          totalQuantity > 0 ? discount / totalQuantity : 0;
        setDiscount(finalDiscountPercentage);
        setQqty(totalQuantity);
        setTotal(subtotal);
        setModelRequestData((PREV) => ({ ...PREV, totalVal: subtotal }));
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const fetchCountryList = async () => {
    try {
      const response = await axios.get(`${BaseUrl}/Country`);
      console.log("Country Response:", response.data); // Log the response

      // Check the response code correctly
      if (response.data.ResponseCode === "0") {
        const countries = response.data.DATA || []; // Access DATA array
        const formattedCountryList = countries.map((country) => ({
          value: country.COUNTRY_ID,
          label: country.COUNTRY_NAME,
        }));
        setCountryList(formattedCountryList);
      } else {
        console.error(
          "Error fetching countries:",
          response.data.ResponseMessage
        );
      }
    } catch (error) {
      console.error("Error fetching country data:", error);
    }
  };

  const fetchStateList = async (countryID) => {
    if (!countryID) {
      return;
    }
    try {
      const response = await axios.get(
        `${BaseUrl}/State?CountryID=${countryID}`
      );
      console.log("State Response:", response.data); // Log the response

      // Check the response code correctly
      if (response.data.ResponseCode === "0") {
        const states = response.data.DATA || []; // Access DATA array
        const formattedStateList = states.map((state) => ({
          value: state.StateID,
          label: state.StateName,
        }));
        setStateList(formattedStateList);
      } else {
        console.error("Error fetching states:", response.data.ResponseMessage);
      }
    } catch (error) {
      console.error("Error fetching state data:", error);
    }
  };
  useEffect(() => {
    GetDeliveryChargesLookupListData();
  }, [shipAdd]);

  useEffect(() => {
    let Prod_Id = [];
    if (isProductCart) {
      product.forEach((products) => {
        Prod_Id.push(products.PRODUCT_ID);
      });
    } else {
      product.forEach((products) => {
        Prod_Id.push(products.PrasadID);
      });
    }

    setProductID(Prod_Id); // Removed unnecessary array wrapping
    setCouponObj((prev) => ({ ...prev, subModuleID: Prod_Id, orderAmount: total })); // Same here
  }, [product]);

  console.log('ProductID', productID)
  console.log('Product', product)
  const GetDeliveryChargesLookupListData = async () => {
    if (!shipAdd.districtID) {
      return;
    }
    try {
      const response = await GetDeliveryCharges(
        shipAdd.stateID,
        shipAdd.districtID
      ); // Ensure this function is imported correctly
      if (response?.ResponseCode === "0") {
        const CalculatedShippingCharges = response?.DATA[0].DeliveryCharges;
        setDeliveryChargesAmt(CalculatedShippingCharges);
      } else {
        console.error(
          "Failed to fetch sim Type lookup list:",
          response?.data?.statusMessage || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error fetching sim Type lookup list:", error);
    }
  };

  const fetchDistrictList = async (stateID) => {
    if (!stateID) {
      return;
    }
    try {
      const response = await axios.get(`${BaseUrl}/City?StateID=${stateID}`);
      console.log("District Response:", response.data); // Log the response

      // Check the response code correctly
      if (response.data.ResponseCode === "0") {
        const districts = response.data.DATA || []; // Access DATA array
        const formattedDistrictList = districts.map((district) => ({
          value: district.DistrictID, // Use DistrictID as the identifier
          label: district.DistrictName, // Use DistrictName as the label
        }));
        setCityList(formattedDistrictList); // Update state with the list of districts
      } else {
        console.error(
          "Error fetching districts:",
          response.data.ResponseMessage
        );
      }
    } catch (error) {
      console.error("Error fetching district data:", error);
    }
  };

  const data = localStorage.getItem("userID") || "";

  const getProducts = () => {
    setLoader(true);
    const data = localStorage.getItem("userID");
    axios
      .post(`${BaseUrl}/Estore_Cart?USER_ID=${data}`, {
        USER_ID: data,
        START: 1,
        END: 10,
        WORD: "None",
      })
      .then((res) => {
        setLoader(false);
        const productData = res.data.DATA || [];
        setProduct(productData);
        // Calculate total, discount, and quantity
        let discount = 0;
        let totalQuantity = 0;
        let subtotal = 0;

        productData.forEach((product) => {
          const quantity = parseInt(product.QUANTITY) || 0;
          const price =
            product.PRODUCT_PRICE * product.QUANTITY -
            Math.round(
              (product.PRODUCT_PRICE * (product.DISCOUNT * product.QUANTITY)) /
              100
            );

          // const price = parseFloat(product.PRODUCT_PRICE) || 0;
          const discountPercent = parseFloat(product.DISCOUNT) || 0;

          const productTotal = price * quantity;
          totalQuantity += quantity;
          subtotal += price;

          if (discountPercent > 0) {
            discount += discountPercent * quantity;
          }
        });

        const finalDiscountPercentage =
          totalQuantity > 0 ? discount / totalQuantity : 0;
        setDiscount(finalDiscountPercentage);
        setQqty(totalQuantity);
        setTotal(subtotal);
        setModelRequestData((PREV) => ({ ...PREV, totalVal: subtotal }));
      });
  };
  let value, name;

  const updateCartItemCount = (newCount) => {
    if (isTabChange) {
      localStorage.setItem("PrasadcartCount", newCount.toString());
      window.dispatchEvent(new Event("cartUpdated"));
      GetPrasadCart();
    } else {
      console.log("Updating cartItemCount:", newCount);
      localStorage.setItem("cartItemCount", newCount.toString());
      window.dispatchEvent(new Event("cartUpdated"));
      getProducts();
    }
  };

  const deleteProduct = (product) => {
    const toastId = "delete-confirmation"; // fixed ID

    toast(
      (t) => (
        <div>
          <span>Are you sure you want to delete this product?</span>
          <div style={{ marginTop: "10px" }}>
            <button
              style={{
                marginRight: "8px",
                padding: "5px 10px",
                background: "#8f3246",
                color: "white",
                border: "none",
                cursor: "pointer",
                borderRadius: "4px",
              }}
              onClick={() => {
                toast.dismiss(toastId);
                proceedWithDeletion(product);
              }}
            >
              Yes
            </button>
            <button
              style={{
                padding: "5px 10px",
                background: "#dc3545",
                color: "white",
                border: "none",
                cursor: "pointer",
                borderRadius: "4px",
              }}
              onClick={() => toast.dismiss(toastId)}
            >
              No
            </button>
          </div>
        </div>
      ),
      { id: toastId } // <--- this ensures no duplicates
    );
  };

  const proceedWithDeletion = async (product) => {

    if (isTabChange) {
      if (!isAuthenticated) {
        setLoginPopUp(true);
        return;
      }
      if (data && location?.state?.moduleName !== "productBooking") {
        setLoader(true);
        try {
          let response = await Prasad_Cart({
            CART_ID: "1",
            USER_ID: data,
            Prasad_ID: product?.PrasadID,
            QUANTITY: product.QUANTITY,
            TASK: "D",
          }); // Replace with actual import/function call
          if (response?.ResponseCode == "0") {

            setLoader(false);
            toast.success(response?.ResponseMessage);
            let cartItems =
              JSON.parse(localStorage.getItem("PrasadCart")) || [];
            console.log("Cart before deletion:", cartItems);

            cartItems = cartItems.filter(
              (item) => item.PRODUCT_ID != product.PrasadID
            );

            console.log("Cart after deletion:", cartItems);
            localStorage.setItem("PrasadCart", JSON.stringify(cartItems));
            localStorage.setItem(
              "PrasadcartCount",
              JSON.stringify(cartItems.length)
            );

            // ✅ Update cart count
            const newCount = cartItems.length;
            updateCartItemCount(newCount);
            setIsCartUpdate(true)
            if (newCount === 0) {
              setIsPrasadCart(false);
              setIsProductCart(true);
              setIsBothVisible(false);
              setIsTabChange(false);
            }
          } else {
            console.error("Bad request");
            setLoader(false);
          }
        } catch (error) {
          console.log(error);
          setLoader(false);
        }
      } else {
        navigate("/login");
        setIsModalOpen(true);
      }
    } else if (isTabChange === false) {
      setLoader(true);
      axios
        .post(`${BaseUrl}/Estore_Cart`, {
          USER_ID: data,
          CART_ID: product.CART_ID,
          PRODUCT_ID: product.PRODUCT_ID,
          QUANTITY: product.QUANTITY,
          TASK: "D",
        })
        .then((res) => {
          setLoader(false);

          console.log("Delete Response:", res.data);
          getProducts(); // Refresh checkout page after deletion

          if (res.data.ResponseCode === "0") {
            setIsCartUpdate(true)
            let cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
            console.log("Cart before deletion:", cartItems);

            cartItems = cartItems.filter(
              (item) => item.PRODUCT_ID != product.PRODUCT_ID
            );

            console.log("Cart after deletion:", cartItems);
            localStorage.setItem("cartItems", JSON.stringify(cartItems));
            localStorage.setItem(
              "cartItemCount",
              JSON.stringify(cartItems.length)
            );

            // ✅ Update cart count

          }

        })
        .catch((error) => {
          console.error("Error deleting product:", error);
          alert("An error occurred while removing the item from the cart.");
        });
    }
  };

  useEffect(() => {
    calculateTotals();
  }, [product]);

  const calculateTotals = () => {
    const totalDiscountPercentApi = product?.reduce(
      (acc, item) => acc + Number(item.DISCOUNT || 0),
      0
    );
    const totalDiscountRupeeApi = Math.round(
      product?.reduce((acc, item) => {
        return acc + Number(item.DiscountAmount || 0);
      }, 0)
    );
    const totalProductPriceWithOutDiscountApi = product?.reduce(
      (acc, item) => acc + Number(item.PRODUCT_PRICE || 0),
      0
    );
    const totalProductAfterDiscount = Math.round(
      totalProductPriceWithOutDiscountApi - totalDiscountRupeeApi
    );

    const taxAmount = Math.round((totalProductAfterDiscount * 18) / 100); // 18% tax (rounded)
    const finalTotalWithTax = Math.round(totalProductAfterDiscount + taxAmount); // Final total (rounded)
    // const finalTotalWithShippingCharge = Math.round(finalTotalWithTax + deliveryCharges);
    // Final total (rounded)

    setTotalDiscountAmount(totalDiscountRupeeApi);
  };
  const handleClick2 = async (product) => {
    console.log(product.QUANTITY);
    const Quntity = Number(product.QUANTITY);
    console.log(typeof Quntity);

    setQty(product.QUANTITY++);

    //  setQty(product.QUANTITY++);
    if (isTabChange) {
      if (!isAuthenticated) {
        setLoginPopUp(true);
        return;
      }
      if (data) {
        setLoader(true);
        try {
          let response = await Prasad_Cart({
            CART_ID: "1",
            USER_ID: data,
            Prasad_ID: product?.PrasadID,
            QUANTITY: product.QUANTITY,
            TASK: "EDIT",
          }); // Replace with actual import/function call
          if (response?.ResponseCode == "0") {
            GetPrasadCart();
          } else {
            console.error("Bad request");
            setLoader(false);
          }
        } catch (error) {
          console.log(error);
          setLoader(false);
        }
      } else {
        navigate("/login");
        setIsModalOpen(true);
      }
    } else {
      axios
        .post(`${BaseUrl}/Estore_Cart`, {
          USER_ID: data,
          CART_ID: product.CART_ID,
          PRODUCT_ID: product.PRODUCT_ID,
          QUANTITY: product.QUANTITY,
          TASK: "EDIT",
        })
        .then((res) => {
          console.log(res.data);
          getProducts();
          // const newCount = product.length - 1; // Adjust this as necessary
          // updateCartItemCount(newCount);
        });
    }
  };

  // Similar for handleClick1

  const handleClick1 = async (product) => {
    console.log(product.QUANTITY);
    if (product.QUANTITY == 1) {
      return setQty(1);
    } else {
      setQty((product.QUANTITY -= 1));
    }
    if (isTabChange) {
      if (!isAuthenticated) {
        setLoginPopUp(true);
        return;
      }
      if (data) {
        setLoader(true);
        try {
          let response = await Prasad_Cart({
            CART_ID: "1",
            USER_ID: data,
            Prasad_ID: product?.PrasadID,
            QUANTITY: product.QUANTITY,
            TASK: "EDIT",
          }); // Replace with actual import/function call
          if (response?.ResponseCode == "0") {
            GetPrasadCart();
          } else {
            console.error("Bad request");
            setLoader(false);
          }
        } catch (error) {
          console.log(error);
          setLoader(false);
        }
      } else {
        navigate("/login");
        setIsModalOpen(true);
      }
    } else {
      axios
        .post(`${BaseUrl}/Estore_Cart`, {
          USER_ID: data,
          CART_ID: product.CART_ID,
          PRODUCT_ID: product.PRODUCT_ID,
          QUANTITY: product.QUANTITY,
          TASK: "EDIT",
        })
        .then((res) => {
          console.log(res.data);
          getProducts();
          // const newCount = product.length - 1; // Adjust this as necessary
          // updateCartItemCount(newCount);
        });
    }
  };

  const navigate = useNavigate();

  const functionOne = () => {
    let isValid = true;

    // Validate shipping address
    if (
      shipAdd?.PinCode === null ||
      shipAdd?.PinCode === undefined ||
      shipAdd?.PinCode === "" ||
      shipAdd?.Flat === null ||
      shipAdd?.Flat === undefined ||
      shipAdd?.Flat === "" ||
      shipAdd?.Colony === null ||
      shipAdd?.Colony === undefined ||
      shipAdd?.Colony === "" ||
      shipAdd?.Landmark === null ||
      shipAdd?.Landmark === undefined ||
      shipAdd?.Landmark === "" ||
      shipAdd?.City === null ||
      shipAdd?.City === undefined ||
      shipAdd?.City === ""
      // shipAdd?.State === null || shipAdd?.State === undefined || shipAdd?.State === ''
      // shipAdd?.Payment === null || shipAdd?.Payment === undefined || shipAdd?.Payment === ''
    ) {
      setError(true);
      isValid = false;
    }
    if (isValid) {
      PaymentApproved("online"); // Always online payment
    }
    // For cash payment, keep existing behavior; for online, process full payment
    // if (isValid && payment === 'cash') {
    //   setModelRequestData((prev) => ({
    //     ...prev, TotalPayableAmount: (total - discount).toFixed(2)
    //   }))
    //   setShowCodModal(true);
    //   const offcanvasElement = document.getElementById("offcanvasRight");
    //   if (offcanvasElement) {
    //     const offcanvasInstance = Offcanvas.getInstance(offcanvasElement);
    //     offcanvasInstance?.hide();
    //   }
    // } else if (isValid && payment === 'online') {
    //   PaymentApproved("online");
    // }
  };

  const handlePhonePayPayment = (paymentMode) => {
    const User_Id = localStorage.getItem("userID");
    const { PinCode, Flat, Colony, Landmark, City, State, Payment } = shipAdd;

    let Prod_Id = "";
    let Prod_Price = "";
    let Prod_Discount = "";
    let Prod_Quantity = "";
    if (isTabChange) {
      product.forEach((products) => {
        Prod_Id = Prod_Id.concat(",", products.PrasadID);
        Prod_Price = Prod_Price.concat(",", products.PrasadPrice);
        Prod_Discount = Prod_Discount.concat(",", products.DISCOUNT);
        Prod_Quantity = Prod_Quantity.concat(",", products.QUANTITY);
      });
    } else {
      product.forEach((products) => {
        Prod_Id = Prod_Id.concat(",", products.PRODUCT_ID);
        Prod_Price = Prod_Price.concat(",", products.PRODUCT_PRICE);
        Prod_Discount = Prod_Discount.concat(",", products.DISCOUNT);
        Prod_Quantity = Prod_Quantity.concat(",", products.QUANTITY);
      });
    }

    const Prod_Id1 = Prod_Id.slice(1);
    const Prod_Price1 = Prod_Price.slice(1);
    const Prod_Discount1 = Prod_Discount.slice(1);
    const Prod_Quantity1 = Prod_Quantity.slice(1);

    let date = dayjs().add(5, "day").format("YYYY-MM-DD");

    const ToTalAmount =
      parseFloat(total) + parseFloat(deliveryChargesAmt) - discount;
    let finalPayment =
      paymentMode === "online"
        ? ToTalAmount.toFixed(2)
        : (ToTalAmount * 0.2).toFixed(2);
    let remainingAmount =
      paymentMode === "online"
        ? "0.00"
        : (ToTalAmount - finalPayment).toFixed(2);

    let PrasadPAYLOADData = null;
    let eStorePAYLOADData = null;
    if (isTabChange) {
      const PhonePayOption = {
        UserID: User_Id,
        MobileNumber: "",
        ModalName: "prasadBookingModal",
        Amount: grandTotal,
      };

      PrasadPAYLOADData = {
        USER_ID: User_Id,
        TotalQty: `${qqty}`,
        TotalPrice: `${total}`,
        TotalDiscount: `${totalDiscountAmount}`,
        RATE: `${Prod_Price1}`,
        // PRODUCT_ID: `${Prod_Id1}`,
        QTY: `${Prod_Quantity1}`,
        DISCOUNT: `${Prod_Discount1}`,
        OrderAddress: `${PinCode} ${Flat} ${Colony} ${Landmark} ${City} ${State} ${Payment}`,
        DeliveryCharges: `${deliveryChargesAmt}`,
        TRANSACTION_AMT: grandTotal,
        // TRANSACTION_ID: PlaceOrderResponse?.razorpay_payment_id,
        TotalItem: qqty,
        DeliveryDate: dayjs().add(3, 'day'),
        TotalDiscountAmount: DiscountAmountForApi,
        TotalAmountOfPrasad: RealTotalPriceAmt,
        DeliveryCharges: deliveryChargesAmt,
        TotalAmount: SubTotalVal,
        TaxPercentage: 18,
        TaxAmount: TaxAmtVal,
        GrandTotal: grandTotal,
        PRASAD_ID: Prod_Id1,
      };

      axios
        .post(`${BaseUrl}/${GetPhonePayPaymentLink}`, PhonePayOption)
        .then((res) => {
          if (res?.data?.success) {
            console.log("PhonePe Response:", res.data);

            // Use navigate with state instead of window.location.href
            localStorage.setItem(
              "prasadBooking",
              JSON.stringify(PrasadPAYLOADData)
            );

            window.location.href = res.data.redirectUrl;
          } else {
            console.error("PhonePe Payment Failed:", res.data);
            alert("Something went wrong while creating the payment link.");
          }
        })
        .catch((error) => {
          console.error("PhonePe API Error:", error);
          alert("Failed to initiate PhonePe payment. Please try again.");
        });
    } else {
      const PhonePayOption = {
        UserID: User_Id,
        MobileNumber: "",
        ModalName: "eStoreModal",
        Amount: grandTotal,
      };

      eStorePAYLOADData = {
        USER_ID: User_Id,
        TOTAL_QTY: `${qqty}`,
        TOTAL_PRICE: `${total}`,
        TOTAL_DISC: `${totalDiscountAmount}`,
        RATE: `${Prod_Price1}`,
        // PRODUCT_ID: `${Prod_Id1}`,
        QTY: `${Prod_Quantity1}`,
        DISCOUNT: `${Prod_Discount1}`,
        ORDER_ADDRESS: `${PinCode} ${Flat} ${Colony} ${Landmark} ${City} ${State} ${Payment}`,
        SHIPING_CHARGES: `${deliveryChargesAmt}`,
        TRANSACTION_AMT: grandTotal,
        // TRANSACTION_ID: PlaceOrderResponse?.razorpay_payment_id,
        TotalItem: qqty,
        TotalDiscountAmount: DiscountAmountForApi,
        TotalAmountOfProduct: RealTotalPriceAmt,
        DeliveryCharges: deliveryChargesAmt,
        TotalAmount: SubTotalVal,
        TaxPercentage: 18,
        TaxAmount: TaxAmtVal,
        GrandTotal: grandTotal,
        [isTabChange ? "PRASAD_ID" : "PRODUCT_ID"]: `${Prod_Id1}`,
      };

      axios
        .post(`${BaseUrl}/${GetPhonePayPaymentLink}`, PhonePayOption)
        .then((res) => {
          if (res?.data?.success) {
            console.log("PhonePe Response:", res.data);

            // Use navigate with state instead of window.location.href
            localStorage.setItem(
              "estorePurchased",
              JSON.stringify(eStorePAYLOADData)
            );

            window.location.href = res.data.redirectUrl;
          } else {
            console.error("PhonePe Payment Failed:", res.data);
            alert("Something went wrong while creating the payment link.");
          }
        })
        .catch((error) => {
          console.error("PhonePe API Error:", error);
          alert("Failed to initiate PhonePe payment. Please try again.");
        });
    }
  };
  const PaymentApproved = async (paymentMode) => {
    const User_Id = localStorage.getItem("userID");
    const { PinCode, Flat, Colony, Landmark, City, State, Payment } = shipAdd;

    let Prod_Id = "";
    let Prod_Price = "";
    let Prod_Discount = "";
    let Prod_Quantity = "";
    if (isTabChange) {
      product.forEach((products) => {
        Prod_Id = Prod_Id.concat(",", products.PrasadID);
        Prod_Price = Prod_Price.concat(",", products.PrasadPrice);
        Prod_Discount = Prod_Discount.concat(",", products.DISCOUNT);
        Prod_Quantity = Prod_Quantity.concat(",", products.QUANTITY);
      });
    } else {
      product.forEach((products) => {
        Prod_Id = Prod_Id.concat(",", products.PRODUCT_ID);
        Prod_Price = Prod_Price.concat(",", products.PRODUCT_PRICE);
        Prod_Discount = Prod_Discount.concat(",", products.DISCOUNT);
        Prod_Quantity = Prod_Quantity.concat(",", products.QUANTITY);
      });
    }

    const Prod_Id1 = Prod_Id.slice(1);
    setProductID(Prod_Id1)
    const Prod_Price1 = Prod_Price.slice(1);
    const Prod_Discount1 = Prod_Discount.slice(1);
    const Prod_Quantity1 = Prod_Quantity.slice(1);

    let date = dayjs().add(5, "day").format("YYYY-MM-DD");

    const ToTalAmount =
      parseFloat(total) + parseFloat(deliveryChargesAmt) - discount;
    let finalPayment =
      paymentMode === "online"
        ? ToTalAmount.toFixed(2)
        : (ToTalAmount * 0.2).toFixed(2);
    let remainingAmount =
      paymentMode === "online"
        ? "0.00"
        : (ToTalAmount - finalPayment).toFixed(2);

    if (
      shipAdd.City &&
      shipAdd.PinCode &&
      shipAdd.Flat &&
      shipAdd.Colony &&
      shipAdd.Landmark &&
      shipAdd.State
    ) {
      let PAYLOAD = null
      const PlaceOrderResponse = await handleProceedRemainingPayment(Math.round(grandTotal))
      console.log('PlaceOrderResponse', PlaceOrderResponse)
      if (PlaceOrderResponse?.status === 1) {
        if (isTabChange) {
          PAYLOAD = {
            USER_ID: User_Id,
            TotalQty: `${qqty}`,
            TotalPrice: `${total}`,
            TotalDiscount: `${totalDiscountAmount}`,
            RATE: `${Prod_Price1}`,
            // PRODUCT_ID: `${Prod_Id1}`,
            QTY: `${Prod_Quantity1}`,
            DISCOUNT: `${Prod_Discount1}`,
            OrderAddress: `${PinCode} ${Flat} ${Colony} ${Landmark} ${City} ${State} ${Payment}`,
            DeliveryCharges: `${deliveryChargesAmt}`,
            TRANSACTION_AMT: grandTotal,
            TRANSACTION_ID: PlaceOrderResponse?.razorpay_payment_id,
            TotalItem: qqty,
            DeliveryDate: dayjs().add(3, 'day'),
            TotalDiscountAmount: DiscountAmountForApi,
            TotalAmountOfPrasad: RealTotalPriceAmt,
            DeliveryCharges: deliveryChargesAmt,
            TotalAmount: SubTotalVal,
            TaxPercentage: 18,
            TaxAmount: TaxAmtVal,
            GrandTotal: grandTotal,
            PRASAD_ID: Prod_Id1,
            CouponCodeID: appliedCoupon?.couponCodeID,
            CouponCodeAmount: appliedCoupon?.CoupenAmount,
            WalletAmount: appliedCoupon?.walletAmount,
            ApplicationType: 'Website'
          };
        } else {
          PAYLOAD = {
            USER_ID: User_Id,
            TOTAL_QTY: `${qqty}`,
            TOTAL_PRICE: `${total}`,
            TOTAL_DISC: `${totalDiscountAmount}`,
            RATE: `${Prod_Price1}`,
            // PRODUCT_ID: `${Prod_Id1}`,
            QTY: `${Prod_Quantity1}`,
            DISCOUNT: `${Prod_Discount1}`,
            ORDER_ADDRESS: `${PinCode} ${Flat} ${Colony} ${Landmark} ${City} ${State} ${Payment}`,
            SHIPING_CHARGES: `${deliveryChargesAmt}`,
            TRANSACTION_AMT: grandTotal,
            TRANSACTION_ID: PlaceOrderResponse?.razorpay_payment_id,
            TotalItem: qqty,
            TotalDiscountAmount: DiscountAmountForApi,
            TotalAmountOfProduct: RealTotalPriceAmt,
            DeliveryCharges: deliveryChargesAmt,
            TotalAmount: SubTotalVal,
            TaxPercentage: 18,
            TaxAmount: TaxAmtVal,
            GrandTotal: grandTotal,
            [isTabChange ? "PRASAD_ID" : "PRODUCT_ID"]: `${Prod_Id1}`,
            CouponCodeID: appliedCoupon?.couponCodeID,
            CouponCodeAmount: appliedCoupon?.CoupenAmount,
            WalletAmount: appliedCoupon?.walletAmount,
          };
        }
        if (isTabChange) {
          setLoader(true);
          axios
            .post(`${BaseUrl}/Prasad/Prasad_Order`, PAYLOAD)
            .then((response) => {
              if (response.data.ResponseMessage === "Order Success.") {

                if (isTabChange) {
                  localStorage.setItem("PrasadcartCount", "0");
                  localStorage.setItem("PrasadCart", []);
                  navigate("/thank-you", {
                    state: { moduleName: "PrasadBooking" },
                  });

                }
                // else {
                //   localStorage.setItem("cartItemCount", "0");
                //   localStorage.setItem("cartItems", []);
                //   navigate("/thank-you", {
                //     state: { moduleName: "MyStore" },
                //   });
                // }
                window.dispatchEvent(new Event("cartUpdated"));
                setIsCartUpdate(true);
                setLoader(false);
                // navigate("/thank-you", { state: { paymentData: PAYLOAD } });
              } else {
                setLoader(false);
                alert("Order placement failed, please try again.");
              }
            })
            .catch((err) => {
              setLoader(false);
              console.error("Order Error:", err);
            });
        } else {
          setLoader(true)
          axios
            .post(`${BaseUrl}/Estore_order`, PAYLOAD)
            .then((response) => {
              if (response.data.ResponseMessage === "Order Success.") {
                localStorage.setItem("cartItemCount", "0");
                window.dispatchEvent(new Event("cartUpdated"));
                navigate("/thank-you", {
                  state: { moduleName: "MyStore" },
                });
                // navigate("/thank-you", { state: { paymentData: PAYLOAD } });
                setIsCartUpdate(true);
                setLoader(false)
              } else {
                setLoader(false)
                alert("Order placement failed, please try again.");
              }
            })
            .catch((err) => console.error("Order Error:", err));
        }
      } else if (PlaceOrderResponse?.status === 0) {
        setLoader(false)
        alert('Order Failed !')
      }
    } else {
      ValidationToast();

    }
  };

  const grandTotal = Math.round(
    (total - totalDiscountAmount) * 1.18 + Number(deliveryChargesAmt) - couponAmount
  );
  const DiscountAmountForApi = Math.round(totalDiscountAmount);
  const RealTotalPriceAmt = Math.round(total);
  const SubTotalVal = Math.round(total - totalDiscountAmount);
  const TaxAmtVal = Math.round((total - totalDiscountAmount) * 0.18);

  // const total-totalDiscountAmount
  console.log(RealTotalPriceAmt, "DiscountAmountdddddddddddddd3");
  const allFieldsFilled =
    shipAdd.City &&
    shipAdd.Flat &&
    shipAdd.Colony &&
    shipAdd.Landmark &&
    shipAdd.PinCode &&
    shipAdd.State;
  const [couponObj, setCouponObj] = useState({
    userID: userID,
    serviceID: isPrasadCart ? FaqModuleID?.PrasadBooking : FaqModuleID?.EstoreBooking,
    subModuleID: productID,
    orderAmount: Math.round(total)

  })
  const PrasadCart = () => {
    return (
      <>
        <div className="container mt-4 ">
          {product?.length > 0 ? (
            <>
              <div className="row w-100">
                {/* Left Section - Cart Items */}
                <div className="col-md-8">
                  {showProductDetails ? (
                    // Product Details UI
                    <>
                      <h5>Prasad Details</h5>
                      {product?.map((item) => (
                        <div
                          key={item.id}
                          className="card mb-3 p-3 shadow-sm position-relative"
                        >
                          {/* Remove button */}
                          <button
                            className="btn btn-sm btn-outline-secondary position-absolute"
                            style={{ top: "10px", right: "10px" }}
                            onClick={() => deleteProduct(item)}
                          >
                            <i className="fa-solid fa-trash"></i>
                          </button>

                          <div className="row g-3 align-items-center">
                            {/* Product Image */}
                            <div className="col-3">
                              <img
                                src={item.PrasadPhotoURL || fav}
                                alt="Prasad image"
                                className="img-fluid rounded"
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  objectFit: "cover",
                                }}
                              />
                            </div>

                            {/* Product Details */}
                            <div className="col-9">
                              <h5 className="mb-1">{item.PrasadName}</h5>
                              <h6 style={{ color: "#A42642" }}>
                                ₹{" "}
                                {Number(
                                  item.PrasadPrice * Number(item.QUANTITY)
                                ) - Math.round(Number(item.DiscountAmount))}
                                {Number(item.DISCOUNT) <= 0 && (
                                  <>
                                    <span
                                      className="text-muted ms-2"
                                      style={{
                                        textDecoration: "line-through",
                                        fontSize: "14px",
                                      }}
                                    >
                                      ₹{" "}
                                      {item.PrasadPrice *
                                        Number(item?.QUANTITY)}
                                    </span>
                                    <p>
                                      <span
                                        style={{ background: "#8f3246" }}
                                        className="badge"
                                      >
                                        Discount {item.DISCOUNT}%
                                      </span>
                                    </p>
                                  </>
                                )}
                              </h6>

                              {/* Quantity Controls */}
                              <div className="d-flex align-items-center gap-2">
                                <button
                                  className="btn btn-sm btn-outline-custom"
                                  onClick={() => handleClick1(item)}
                                >
                                  -
                                </button>
                                <span>{item.QUANTITY}</span>
                                <button
                                  className="btn btn-sm btn-outline-custom"
                                  onClick={() => handleClick2(item)}
                                >
                                  +
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    // Address Input UI
                    <>
                      <div class="mb-3 ">
                        <Select
                          styles={customSelectStyles}
                          name="Country"
                          placeholder="Select Country"
                          options={countryList}
                          value={
                            countryList.find(
                              (country) => country.value === shipAdd?.countryID
                            ) || null
                          } // Ensure correct list
                          onChange={(e) => {
                            const selectedCountry = countryList.find(
                              (country) => country.value === e.value
                            );

                            if (selectedCountry) {
                              setShipAdd((prev) => ({
                                ...prev,
                                Country: selectedCountry.label, // Store Country Name
                                countryID: selectedCountry.value, // Store Country ID
                              }));
                            }

                            setSelectedCountry(e.value);
                            setStateList([]); // Reset state when country changes
                            setCityList([]); // Reset city when country changes
                            fetchStateList(e.value); // Fetch new state list based on country
                          }}
                        />
                      </div>
                      <div class="mb-3 ">
                        <Select
                          styles={customSelectStyles}
                          name="State"
                          placeholder="Select State"
                          options={stateList}
                          value={
                            stateList.find(
                              (state) => state.value === shipAdd?.stateID
                            ) || null
                          }
                          onChange={(e) => {
                            setSelectedState(e.value);
                            const selectedState = stateList.find(
                              (state) => state.value === e.value
                            );

                            if (selectedState) {
                              setShipAdd((prev) => ({
                                ...prev,
                                State: selectedState.label,
                                stateID: selectedState.value, // Store StateID
                              }));
                            }
                          }}
                        />
                      </div>
                      <div class="mb-3 ">
                        <Select
                          styles={customSelectStyles}
                          name="City"
                          placeholder="Select City"
                          options={cityList}
                          value={
                            cityList.find(
                              (city) => city.value === shipAdd?.districtID
                            ) || null
                          } // Fix here
                          onChange={(e) => {
                            const selectedCity = cityList.find(
                              (city) => city.value === e.value
                            );

                            if (selectedCity) {
                              setShipAdd((prev) => ({
                                ...prev,
                                City: selectedCity.label,
                                districtID: selectedCity.value, // Store DistrictID
                              }));
                            }
                          }}
                        />
                      </div>

                      <div class="mb-3 ">
                        <input
                          type="text"
                          placeholder=" Pincode"
                          className="custom-form-control"
                          id="pincode"
                          value={shipAdd?.PinCode || ""}
                          maxLength={6}
                          onChange={(e) => {
                            // Remove non-alphabet characters except spaces
                            const formattedInput = e.target.value
                              .replace(/[^\d]/g, "")
                              .trim();

                            setShipAdd((prev) => ({
                              ...prev,
                              PinCode: formattedInput, // Update Flat instead of name
                            }));
                          }}
                        />
                        {error &&
                          (shipAdd?.PinCode === "" ||
                            shipAdd?.PinCode === null ||
                            shipAdd?.PinCode === undefined) ? (
                          <span
                            className="text-danger"
                            style={{ fontSize: "small" }}
                          >
                            {ERROR_MESSAGES}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder="House No./Building No."
                          className="custom-form-control"
                          value={shipAdd?.Flat || ""}
                          onChange={(e) => {
                            setShipAdd((prev) => ({
                              ...prev,
                              Flat: e.target.value,
                            }));
                          }}
                        />
                        {error &&
                          (!shipAdd?.Flat || shipAdd?.Flat.trim() === "") && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "small" }}
                            >
                              {ERROR_MESSAGES}
                            </span>
                          )}
                      </div>

                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder="Road name/Area/Colony"
                          className="custom-form-control"
                          value={shipAdd?.Colony || ""}
                          onChange={(e) => {
                            setShipAdd((prev) => ({
                              ...prev,
                              Colony: e.target.value,
                            }));
                          }}
                        />
                        {error &&
                          (!shipAdd?.Colony ||
                            shipAdd?.Colony.trim() === "") && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "small" }}
                            >
                              {ERROR_MESSAGES}
                            </span>
                          )}
                      </div>

                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder="Landmark"
                          className="custom-form-control"
                          value={shipAdd?.Landmark || ""}
                          onChange={(e) => {
                            setShipAdd((prev) => ({
                              ...prev,
                              Landmark: e.target.value,
                            }));
                          }}
                        />
                        {error &&
                          (!shipAdd?.Landmark ||
                            shipAdd?.Landmark.trim() === "") && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "small" }}
                            >
                              {ERROR_MESSAGES}
                            </span>
                          )}
                      </div>
                    </>
                  )}
                </div>

                {/* Right Section - Price Summary */}
                <div className="col-md-4">
                  <h5>Price Details ({product?.length} Items)</h5>
                  <div className="card p-3 shadow-sm">
                    <div>
                      {appliedCoupon?.isApplied ? (
                        <div
                          onClick={() => handleOpenCoupenModal()}
                          style={{
                            backgroundColor: 'rgb(239 178 29)',
                            borderRadius: '10px',
                            padding: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            color: '#000',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            width: '100%',

                          }}

                        >
                          <div className="mb-2" style={{ display: 'flex', alignItems: 'center' }}>

                            <span>Applied Coupon</span>
                            {appliedCoupon && (
                              <span
                                style={{
                                  border: '1px dotted #333',
                                  padding: '2px 6px',
                                  borderRadius: '4px',
                                  fontSize: '12px',
                                  backgroundColor: '#fff',
                                  color: '#333',
                                  marginLeft: '6px',
                                }}
                              >
                                {appliedCoupon?.CouponCode}
                              </span>
                            )}
                          </div>
                          <span
                            onClick={() => {
                              setAppliedCoupon((prev) => ({
                                ...prev, CouponCode: null,
                                isApplied: false,
                                CoupenAmount: 0,
                                walletAmount: 0
                              }))
                            }}
                            style={{
                              // border: '1px dotted #333',
                              padding: '2px 6px',
                              borderRadius: '4px',
                              fontSize: '12px',
                              backgroundColor: '#fff',
                              color: '#a52444',
                              marginLeft: '6px',
                            }} >



                            Remove

                          </span>
                          <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span>
                        </div>
                      ) : (
                        <div
                          onClick={() => handleOpenCoupenModal()}
                          style={{
                            backgroundColor: 'rgb(239 178 29)',
                            borderRadius: '10px',
                            padding: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',

                            color: '#000',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            width: '100%'
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{
                              backgroundColor: '#a52444',
                              color: 'white',
                              borderRadius: '50%',
                              width: '24px',
                              height: '24px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '14px',
                              marginRight: '10px',

                            }}>
                              %
                            </div>
                            <span>View Coupons & Offers</span>

                          </div>
                          <span style={{ fontSize: '20px', }}>›</span>
                        </div>
                      )}

                    </div>
                    {walletAmount > 0 && (
                      <div className="mt-2" style={{ fontSize: 'smaller', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div

                          style={{
                            backgroundColor: 'rgb(239 178 29)',
                            borderRadius: '10px',
                            padding: '10px',
                            // display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            // cursor: 'pointer',
                            // fontWeight: 'bold',
                            color: '#000',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            width: '100%'
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center' }}>

                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '18px', width: '100%' }}>
                              <input
                                type="checkbox"
                                checked={isWalletApplied}
                                onChange={(e) => {
                                  setAppliedCoupon((PREV) => ({
                                    ...PREV, CouponCode: null,
                                    isApplied: false
                                  }))
                                  setIsWalletApplied(e.target.checked)
                                }
                                }

                                style={{ cursor: 'pointer' }}
                              />
                              Available wallet amount (₹) {walletAmount}
                            </label>
                          </div>
                          {/* <div className="d-flex justify-content-center">

                            <small>(Upto 50% can be applied)</small>
                          </div> */}
                          {/* <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span> */}
                        </div>

                      </div>
                    )}

                    <hr></hr>
                    <div className="d-flex justify-content-between">
                      <p>Total Product Price ₹: </p>
                      <p> {total}</p>


                    </div>
                    <div>
                      {isWalletApplied && appliedCoupon?.isApplied === false ? (
                        <div className="d-flex justify-content-between" style={{ fontSize: '16px' }}>
                          <p>
                            Applied Wallet Amount (₹)

                          </p>
                          <p>
                            - {appliedCoupon?.walletAmount}
                          </p>
                        </div>
                      ) : isWalletApplied === false && appliedCoupon?.isApplied ? (
                        <div className="d-flex justify-content-between" style={{ fontSize: '16px' }}>
                          <p>
                            Applied Coupon  Amount (₹)

                          </p>
                          <p>
                            - {couponAmount}
                          </p>
                        </div>
                      ) : ''}
                    </div>
                    {totalDiscountAmount !== 0 && (
                      <div className="d-flex justify-content-between">
                        <p>Discount amount (₹):</p>
                        <p>- {totalDiscountAmount}</p>
                      </div>
                    )}
                    <hr />
                    <div className="d-flex justify-content-between">
                      <p>Sub Total ₹:</p>
                      <p> {Math.round(total - totalDiscountAmount - couponAmount)}</p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p>Tax (18 %) ₹:</p>
                      <p>+{Math.round((total - totalDiscountAmount) * 0.18)}</p>
                    </div>
                    <hr />

                    <div className="d-flex justify-content-between">
                      <p>Total Amount after Tax</p>
                      <p>
                        ₹{((total - totalDiscountAmount) * 1.18).toFixed(0) - couponAmount}
                      </p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p>
                        Shipping Charges ₹:{" "}
                        <Tooltip title="Shipping Charges will calculate after selecting city.">
                          .<i class="fa-solid fa-circle-info"></i>
                        </Tooltip>
                      </p>
                      <p>+ {deliveryChargesAmt}</p>
                    </div>
                    {/* <div className="d-flex justify-content-between">
                    <p style={{ color: "#8f3246", fontWeight: "bold" }}>
                      Total Discount
                    </p>
                    <p style={{ color: "#8f3246", fontWeight: "bold" }}>
                      - ₹{discount}
                    </p>
                  </div> */}

                    <hr />
                    <div className="d-flex justify-content-between fw-bold">
                      <p>Grand Total</p>
                      <p>₹{grandTotal}</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-start gap-2 mt-2 mb-3">
                    <button
                      style={{ padding: "5px 16px", fontSize: "14px" }}
                      className="Normal-app-btn"
                      onClick={() => setShowProductDetails(!showProductDetails)}
                    >
                      {showProductDetails
                        ? allFieldsFilled
                          ? "Edit Address"
                          : "Enter Address"
                        : "View Products "}
                    </button>

                    {shipAdd.City &&
                      shipAdd.Flat &&
                      shipAdd.Colony &&
                      shipAdd.Landmark &&
                      shipAdd.PinCode &&
                      shipAdd.State &&
                      deliveryChargesAmt && (
                        <>
                          <button
                            style={{ padding: "5px 16px", fontSize: "14px" }}
                            className="Normal-app-btn"
                            onClick={() => PaymentApproved("online")}
                          >
                            Pay
                          </button>
                          {/* <button
                            style={{ background: "#8f3246" }}
                            className="btn text-white"
                            onClick={() => handlePhonePayPayment("online")}
                          >
                            Phone Pay
                          </button> */}
                        </>
                      )}
                  </div>
                  {/* <div className="mt-3 text-center">
                    <p className="mt-2">Your Safety, Our Priority</p>
                    <p className="text-muted small">
                      We make sure that your package is safe at every point of
                      contact.
                    </p>
                  </div> */}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="d-flex justify-content-center  vh-10 w-100" style={{ marginBottom: '22px' }}>
                <div className="text-center">
                  <img
                    src={fav}
                    alt="Empty Cart"
                    className="img-fluid mb-3"
                    width={100}
                    height={100}
                    style={{ maxWidth: "400px" }}
                  />
                  <h5 className="fw-bold">Your cart is empty</h5>
                  <p className="text-muted">
                    Just relax, let us help you find some first-class products
                  </p>
                  <Link to="/prasad-list">
                    <button
                      style={{ padding: '5px 16px', fontSize: '14px' }}
                      className=" Normal-app-btn "
                    >
                      Add More Products{" "}
                      <i className="fa fa-shopping-cart ms-1"></i>
                    </button>
                  </Link>
                </div>
              </div>
            </>
          )}
        </div>
        {showCodModal && (
          <CODPaymentModal
            show={showCodModal}
            onHide={() => setShowCodModal(false)}
            modelRequestData={modelRequestData}
            btnClick={() => PaymentApproved("cash")}
            setModelRequestData={setModelRequestData}
          />
        )}
      </>
    );
  };
  const ProductCart = () => {
    return (
      <>
        <div className="container mt-4 ">
          {product?.length > 0 ? (
            <>
              <div
                className="row w-100 mt-3"
                style={{ "--bs-gutter-x": "6px" }}
              >
                {/* Left Section - Cart Items */}
                <div className="col-md-8 ">
                  {showProductDetails ? (
                    // Product Details UI
                    <>
                      <h5>Product Details</h5>
                      {product?.map((item) => (
                        <div
                          key={item.id}
                          className="card mb-3 p-3 shadow-sm position-relative"
                        >
                          {/* Remove button */}
                          <button
                            className="btn btn-sm btn-outline-secondary position-absolute"
                            style={{ top: "10px", right: "10px" }}
                            onClick={() => deleteProduct(item)}
                          >
                            <i className="fa-solid fa-trash"></i>
                          </button>

                          <div className="row g-3 align-items-center">
                            {/* Product Image */}
                            <div className="col-3">
                              <img
                                src={item.PRODUCT_IMG || placeholderImg}
                                alt={item.PRODUCT_NAME}
                                className="img-fluid rounded"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = placeholderImg;
                                }}
                                style={{
                                  width: "80%",
                                  height: "auto",
                                  objectFit: "cover",
                                }}
                              />
                            </div>

                            {/* Product Details */}
                            <div className="col-9">
                              <h5 className="mb-1">{item.PRODUCT_NAME}</h5>
                              <h6 style={{ color: "#A42642" }}>
                                ₹{" "}
                                {item.PRODUCT_PRICE -
                                  Math.round(
                                    (item.PRODUCT_PRICE * item.DISCOUNT) / 100
                                  )}
                                {Number(item.DISCOUNT) !== 0 && (
                                  <>
                                    <span
                                      className="text-muted ms-2"
                                      style={{
                                        textDecoration: "line-through",
                                        fontSize: "14px",
                                      }}
                                    >
                                      ₹ {item.PRODUCT_PRICE}
                                    </span>
                                    <p>
                                      <span
                                        style={{ background: "#8f3246" }}
                                        className="badge"
                                      >
                                        Discount {item.DISCOUNT}%
                                      </span>
                                    </p>
                                  </>
                                )}
                              </h6>

                              {/* Quantity Controls */}
                              <div className="d-flex align-items-center gap-2">
                                <button
                                  className="btn btn-sm btn-outline-custom"
                                  onClick={() => handleClick1(item)}
                                >
                                  -
                                </button>
                                <span>{item.QUANTITY}</span>
                                <button
                                  className="btn btn-sm btn-outline-custom"
                                  onClick={() => handleClick2(item)}
                                >
                                  +
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    // Address Input UI
                    <>
                      <h5>Address Details</h5>
                      <div style={{ width: "95%" }}>
                        <div class="mb-3 ">
                          <Select
                            styles={customSelectStyles}
                            name="Country"
                            placeholder="Select Country"
                            options={countryList}
                            value={
                              countryList.find(
                                (country) =>
                                  country.value === shipAdd?.countryID
                              ) || null
                            } // Ensure correct list
                            onChange={(e) => {
                              const selectedCountry = countryList.find(
                                (country) => country.value === e.value
                              );

                              if (selectedCountry) {
                                setShipAdd((prev) => ({
                                  ...prev,
                                  Country: selectedCountry.label, // Store Country Name
                                  countryID: selectedCountry.value, // Store Country ID
                                }));
                              }

                              setSelectedCountry(e.value);
                              setStateList([]); // Reset state when country changes
                              setCityList([]); // Reset city when country changes
                              fetchStateList(e.value); // Fetch new state list based on country
                            }}
                          />
                        </div>
                        <div class="mb-3 ">
                          <Select
                            styles={customSelectStyles}
                            name="State"
                            placeholder="Select State"
                            options={stateList}
                            value={
                              stateList.find(
                                (state) => state.value === shipAdd?.stateID
                              ) || null
                            }
                            onChange={(e) => {
                              setSelectedState(e.value);
                              const selectedState = stateList.find(
                                (state) => state.value === e.value
                              );

                              if (selectedState) {
                                setShipAdd((prev) => ({
                                  ...prev,
                                  State: selectedState.label,
                                  stateID: selectedState.value, // Store StateID
                                }));
                              }
                            }}
                          />
                        </div>
                        <div class="mb-3 ">
                          <Select
                            styles={customSelectStyles}
                            name="City"
                            placeholder="Select City"
                            options={cityList}
                            value={
                              cityList.find(
                                (city) => city.value === shipAdd?.districtID
                              ) || null
                            } // Fix here
                            onChange={(e) => {
                              const selectedCity = cityList.find(
                                (city) => city.value === e.value
                              );

                              if (selectedCity) {
                                setShipAdd((prev) => ({
                                  ...prev,
                                  City: selectedCity.label,
                                  districtID: selectedCity.value, // Store DistrictID
                                }));
                              }
                            }}
                          />
                        </div>

                        <div class="mb-3 ">
                          <input
                            type="text"
                            placeholder=" Pincode"
                            className="custom-form-control"
                            id="pincode"
                            value={shipAdd?.PinCode || ""}
                            maxLength={6}
                            onChange={(e) => {
                              // Remove non-alphabet characters except spaces
                              const formattedInput = e.target.value
                                .replace(/[^\d]/g, "")
                                .trim();

                              setShipAdd((prev) => ({
                                ...prev,
                                PinCode: formattedInput, // Update Flat instead of name
                              }));
                            }}
                          />
                          {error &&
                            (shipAdd?.PinCode === "" ||
                              shipAdd?.PinCode === null ||
                              shipAdd?.PinCode === undefined) ? (
                            <span
                              className="text-danger"
                              style={{ fontSize: "small" }}
                            >
                              {ERROR_MESSAGES}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="mb-3">
                          <input
                            type="text"
                            placeholder="House No./Building No."
                            className="custom-form-control"
                            value={shipAdd?.Flat || ""}
                            onChange={(e) => {
                              setShipAdd((prev) => ({
                                ...prev,
                                Flat: e.target.value,
                              }));
                            }}
                          />
                          {error &&
                            (!shipAdd?.Flat || shipAdd?.Flat.trim() === "") && (
                              <span
                                className="text-danger"
                                style={{ fontSize: "small" }}
                              >
                                {ERROR_MESSAGES}
                              </span>
                            )}
                        </div>

                        <div className="mb-3">
                          <input
                            type="text"
                            placeholder="Road name/Area/Colony"
                            className="custom-form-control"
                            value={shipAdd?.Colony || ""}
                            onChange={(e) => {
                              setShipAdd((prev) => ({
                                ...prev,
                                Colony: e.target.value,
                              }));
                            }}
                          />
                          {error &&
                            (!shipAdd?.Colony ||
                              shipAdd?.Colony.trim() === "") && (
                              <span
                                className="text-danger"
                                style={{ fontSize: "small" }}
                              >
                                {ERROR_MESSAGES}
                              </span>
                            )}
                        </div>

                        <div className="mb-3">
                          <input
                            type="text"
                            placeholder="Landmark"
                            className="custom-form-control"
                            value={shipAdd?.Landmark || ""}
                            onChange={(e) => {
                              setShipAdd((prev) => ({
                                ...prev,
                                Landmark: e.target.value,
                              }));
                            }}
                          />
                          {error &&
                            (!shipAdd?.Landmark ||
                              shipAdd?.Landmark.trim() === "") && (
                              <span
                                className="text-danger"
                                style={{ fontSize: "small" }}
                              >
                                {ERROR_MESSAGES}
                              </span>
                            )}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* Right Section - Price Summary */}
                <div className="col-md-4">
                  <h5>Price Details ({product?.length} Items)</h5>
                  <div className="card p-3 shadow-sm">
                    <div>
                      {appliedCoupon?.isApplied ? (
                        <div
                          onClick={() => handleOpenCoupenModal()}
                          style={{
                            backgroundColor: 'rgb(239 178 29)',
                            borderRadius: '10px',
                            padding: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            color: '#000',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            width: '100%',

                          }}

                        >
                          <div className="mb-2" style={{ display: 'flex', alignItems: 'center' }}>

                            <span>Applied Coupon</span>
                            {appliedCoupon && (
                              <span
                                style={{
                                  border: '1px dotted #333',
                                  padding: '2px 6px',
                                  borderRadius: '4px',
                                  fontSize: '12px',
                                  backgroundColor: '#fff',
                                  color: '#333',
                                  marginLeft: '6px',
                                }}
                              >
                                {appliedCoupon?.CouponCode}
                              </span>
                            )}
                          </div>
                          <span
                            onClick={() => {
                              setAppliedCoupon((prev) => ({
                                ...prev, CouponCode: null,
                                isApplied: false,
                                CoupenAmount: 0,
                                walletAmount: 0
                              }))
                            }}
                            style={{
                              // border: '1px dotted #333',
                              padding: '2px 6px',
                              borderRadius: '4px',
                              fontSize: '12px',
                              backgroundColor: '#fff',
                              color: '#a52444',
                              marginLeft: '6px',
                            }} >



                            Remove

                          </span>
                          <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span>
                        </div>
                      ) : (
                        <div
                          onClick={() => setShowModal(true)}
                          style={{
                            backgroundColor: 'rgb(239 178 29)',
                            borderRadius: '10px',
                            padding: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            color: '#000',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            width: '100%'
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{
                              backgroundColor: '#a52444',
                              color: 'white',
                              borderRadius: '50%',
                              width: '24px',
                              height: '24px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '14px',
                              marginRight: '10px',

                            }}>
                              %
                            </div>
                            <span>View Coupons & Offers</span>

                          </div>
                          <span style={{ fontSize: '20px', fontWeight: 'bolder' }}>›</span>
                        </div>
                      )}

                    </div>
                    {walletAmount > 0 && (
                      <div className="mt-2" style={{ fontSize: 'smaller', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div

                          style={{
                            backgroundColor: 'rgb(239 178 29)',
                            borderRadius: '10px',
                            padding: '10px',
                            // display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            // cursor: 'pointer',
                            // fontWeight: 'bold',
                            color: '#000',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            width: '100%'
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center' }}>

                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '18px', width: '100%' }}>
                              <input
                                type="checkbox"
                                checked={isWalletApplied}
                                onChange={(e) => {
                                  setAppliedCoupon((PREV) => ({
                                    ...PREV, CouponCode: null,
                                    isApplied: false
                                  }))
                                  setIsWalletApplied(e.target.checked)
                                }
                                }

                                style={{ cursor: 'pointer' }}
                              />
                              Available wallet amount (₹) {walletAmount}
                            </label>
                          </div>
                          {/* <div className="d-flex justify-content-center">

                            <small>(Upto 50% can be applied)</small>
                          </div> */}
                          {/* <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span> */}
                        </div>

                      </div>
                    )}

                    <hr></hr>
                    <div className="d-flex justify-content-between">
                      <p>Total Product Price ₹: </p>
                      <p> {total}</p>


                    </div>
                    <div>
                      {isWalletApplied && appliedCoupon?.isApplied === false ? (
                        <div className="d-flex justify-content-between" style={{ fontSize: '16px' }}>
                          <p>
                            Applied Wallet Amount (₹)

                          </p>
                          <p>
                            - {appliedCoupon?.walletAmount}
                          </p>
                        </div>
                      ) : isWalletApplied === false && appliedCoupon?.isApplied ? (
                        <div className="d-flex justify-content-between" style={{ fontSize: '16px' }}>
                          <p>
                            Applied Coupon  Amount (₹)

                          </p>
                          <p>
                            - {couponAmount}
                          </p>
                        </div>
                      ) : ''}
                    </div>
                    {totalDiscountAmount !== 0 && (
                      <div className="d-flex justify-content-between">
                        <p>Discount amount (₹):</p>
                        <p>- {totalDiscountAmount}</p>
                      </div>
                    )}
                    <hr />
                    <div className="d-flex justify-content-between">
                      <p>Sub Total ₹:</p>
                      <p> {Math.round(total - totalDiscountAmount - couponAmount)}</p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p>Tax (18 %) ₹:</p>
                      <p>+{Math.round((total - totalDiscountAmount) * 0.18)}</p>
                    </div>
                    <hr />

                    <div className="d-flex justify-content-between">
                      <p>Total Amount after Tax</p>
                      <p>
                        ₹{((total - totalDiscountAmount) * 1.18).toFixed(0) - couponAmount}
                      </p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p>
                        Shipping Charges ₹:{" "}
                        <Tooltip title="Shipping Charges will calculate after selecting city.">
                          .<i class="fa-solid fa-circle-info"></i>
                        </Tooltip>
                      </p>
                      <p>+ {deliveryChargesAmt}</p>
                    </div>
                    {/* <div className="d-flex justify-content-between">
                    <p style={{ color: "#8f3246", fontWeight: "bold" }}>
                      Total Discount
                    </p>
                    <p style={{ color: "#8f3246", fontWeight: "bold" }}>
                      - ₹{discount}
                    </p>
                  </div> */}

                    <hr />
                    <div className="d-flex justify-content-between fw-bold">
                      <p>Grand Total</p>
                      <p>₹{grandTotal}</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-start gap-2 mt-2 mb-3">
                    <button
                      style={{ padding: "5px 16px", fontSize: "14px" }}
                      className="Normal-app-btn"
                      onClick={() => setShowProductDetails(!showProductDetails)}
                    >
                      {showProductDetails
                        ? allFieldsFilled
                          ? "Edit Address"
                          : "Enter Address"
                        : "View Products "}
                    </button>

                    {shipAdd.City &&
                      shipAdd.Flat &&
                      shipAdd.Colony &&
                      shipAdd.Landmark &&
                      shipAdd.PinCode &&
                      shipAdd.State &&
                      deliveryChargesAmt && (
                        <>
                          <button
                            style={{ padding: "5px 16px", fontSize: "14px" }}
                            className="Normal-app-btn"
                            onClick={() => PaymentApproved("online")}
                          >
                            Pay
                          </button>
                          {/* <button
                            style={{ background: "#8f3246" }}
                            className="btn text-white"
                            onClick={() => handlePhonePayPayment("online")}
                          >
                            Phone Pay
                          </button> */}
                        </>
                      )}
                  </div>
                  {/* <div className="mt-3 text-center">
                    <p className="mt-2">Your Safety, Our Priority</p>
                    <p className="text-muted small">
                      We make sure that your package is safe at every point of
                      contact.
                    </p>
                  </div> */}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="d-flex justify-content-center  vh-10 w-100" style={{ marginBottom: '22px' }}>
                <div className="text-center">
                  <img
                    src={fav}
                    alt="Empty Cart"
                    className="img-fluid mb-3"
                    width={100}
                    height={100}
                    style={{ maxWidth: "400px" }}
                  />
                  <h5 className="fw-bold">Your cart is empty</h5>
                  <p className="text-muted">
                    Just relax, let us help you find some first-class products
                  </p>
                  <Link to="/my-store">
                    <button
                      style={{ padding: '5px 16px', fontSize: '14px' }}
                      className=" Normal-app-btn "
                    >
                      Add More Products{" "}
                      <i className="fa fa-shopping-cart ms-1"></i>
                    </button>
                  </Link>
                </div>
              </div>
            </>
          )}
        </div>
        {showCodModal && (
          <CODPaymentModal
            show={showCodModal}
            onHide={() => setShowCodModal(false)}
            modelRequestData={modelRequestData}
            btnClick={() => PaymentApproved("cash")}
            setModelRequestData={setModelRequestData}
          />
        )}

      </>
    );
  };

  return (
    <>
      {isPrasadCart && PrasadCart()}
      {isProductCart && ProductCart()}
      {isBothVisible && (
        <>
          <div className="container mt-4">
            {product?.length > 0 ? (
              <Tab.Container
                defaultActiveKey={showProductTabDetails ? "products" : "Prasad"}
              >
                <div className="row w-100">
                  {/* Left Section - Tabs and Content */}
                  <div className="col-md-12">
                    <Nav variant="tabs" defaultActiveKey="products">
                      <Nav.Item>
                        <Nav.Link
                          eventKey="products"
                          onClick={() => {
                            setShowProductTabDetails(true);
                            setShowProductDetails(true);
                            setIsTabChange(false);
                          }}
                          style={{ color: isTabChange ? "#a52444" : "black" }}
                        >
                          Products
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="prasad"
                          onClick={() => {
                            setShowProductTabDetails(false);
                            setShowProductDetails(true);
                            setIsTabChange(true);
                          }}
                          style={{ color: "#a52444" }}
                        >
                          Prasad
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>

                    <Tab.Content className="mt-3">
                      {/* Product Tab */}

                      <Tab.Pane eventKey="products">{ProductCart()}</Tab.Pane>

                      {/* Prasad Tab */}

                      <Tab.Pane eventKey="prasad">{PrasadCart()}</Tab.Pane>
                    </Tab.Content>
                  </div>
                </div>
              </Tab.Container>
            ) : (
              <div className="d-flex justify-content-center align-items-center vh-10 w-100" style={{ marginBottom: '22px' }}>
                <div className="text-center">
                  <img
                    src={fav}
                    alt="Empty Cart"
                    className="img-fluid mb-3"
                    width={100}
                    height={100}
                    style={{ maxWidth: "400px" }}
                  />
                  <h5 className="fw-bold">Your cart is empty</h5>
                  <p className="text-muted">
                    Just relax, let us help you find some first-class products
                  </p>
                  <Link to="/my-store">
                    <button
                      style={{ padding: '5px 16px', fontSize: '14px' }}
                      className=" Normal-app-btn "
                    >
                      Add More Products{" "}
                      <i className="fa fa-shopping-cart ms-1"></i>
                    </button>
                  </Link>
                </div>
              </div>
            )}
          </div>
          {showCodModal && (
            <CODPaymentModal
              show={showCodModal}
              onHide={() => setShowCodModal(false)}
              modelRequestData={modelRequestData}
              btnClick={() => PaymentApproved("cash")}
              setModelRequestData={setModelRequestData}
            />
          )}
        </>
      )}
      <CouponModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        modelRequestData={modelRequestData}
        setAppliedCoupon={setAppliedCoupon}
        setIsWalletApplied={setIsWalletApplied}
        apiParam={couponObj} />
    </>
  );
};

export default ViewCart;
